/**
 * アンカーリンク関連の処理
 */
export default class Anchor {
	constructor() {
		this.smoothScroll();
		//this.anchorScroll();
	}
	smoothScroll() {
		$('a[href^="#"]').click(function () {
			var href = $(this).attr('href');
			var target = $(href == '#' || href == '' ? 'html' : href);
			var position = target.offset().top;
			var speed = 500;
			var headerH = $('.l-header').height();
			$('html, body').animate({
				scrollTop: position - (headerH * 1.5)
			}, speed, 'swing');
			return false;
		});
	}
	anchorScroll() {
		const $target = $('.js-fix');
		let $targetPos, isAnimate, targetOffset, wh;
		if ($target.length) {
			$targetPos = $target.height() + 100; // bottom: 100px;
			isAnimate = 'is-fixed';
			targetOffset = $target.offset().top;
			wh = $(window).height();
		}

		$(window).on('scroll load', function () {
			if ($(window).scrollTop() > targetOffset - wh + $targetPos) {
				$target.addClass(isAnimate);
			} else {
				$target.removeClass(isAnimate);
			}
		});
	}
}
